// extracted by mini-css-extract-plugin
module.exports = {"alignmiddle":"ATm6sE"};